import {
  GET_EURONEWS_REJECTED,
  GET_EURONEWS_REQUESTED,
  GET_EURONEWS_RESOLVED,
} from '../actions/types';
import { defaultState, Status } from '../models/europrisme';

const initialState = {
  ...defaultState,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_EURONEWS_REQUESTED: {
      return { ...state, status: Status.LOADING };
    }

    case GET_EURONEWS_RESOLVED: {
      const { data } = action.payload;

      const records = (() => {
        if (!data) {
          return [];
        }

        if (!Array.isArray(data)) {
          return [data];
        }

        return data;
      })();

      return {
        ...state,
        status: Status.IDLE,
        records,
      };
    }

    case GET_EURONEWS_REJECTED: {
      console.error('[EuroNews reducer]', action.payload);

      return { ...state, status: Status.ERROR };
    }

    default:
      return state;
  }
};
